import { useEffect, useState } from 'react';
import type { CurrentUserDto } from '../../../types/UserDtos';
import type { AppContext } from '../hoc/withAppContext';
import { getCurrentUser, subscribe } from '../services/CurrentUser';

const createAppContext = (user: CurrentUserDto): AppContext => ({
    user,
});

export const useAppContext = () => {
    const [appContext, setAppContext] = useState(createAppContext(getCurrentUser()));

    useEffect(() => {
        const unsubscribe = subscribe(updatedCurrentUser => {
            setAppContext(createAppContext(updatedCurrentUser));
        });
        return () => unsubscribe();
    }, []);

    return appContext;
};
